function getSupplementalContext() {
  try {
    return JSON.parse(sessionStorage.getItem('analyticsSupplementalContext'));
  } catch (err) {
    return undefined;
  }
}

function setSupplementalContext(supplementalContext) {
  try {
    if (!supplementalContext) {
      sessionStorage.removeItem('analyticsSupplementalContext');
      return;
    }

    if (typeof supplementalContext === 'function') {
      sessionStorage.setItem(
        'analyticsSupplementalContext',
        JSON.stringify(supplementalContext(getSupplementalContext()))
      );
      return;
    }

    sessionStorage.setItem(
      'analyticsSupplementalContext',
      JSON.stringify(supplementalContext)
    );
  } catch (err) {
    // Do nothing
  }
}

export default {
  getSupplementalContext,
  setSupplementalContext,
};
